import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { allentownConfig } from "./data";

export default function AllentownPage() {
  return <CityPageTemplate config={allentownConfig} />;
}